/**
 * Define file mixin
 *
 * @author minkyoung.park@emcast.com
 */
import { MDCTextField } from "@material/textfield";
import httpService from "@/api/httpService.js";

export const fileMixin = {
  data() {
    return {
      files: [],
      attachments: [],
      thumbnailUrl: require("@/images/blackBackground.jpg"),
      imageFiles: ["image/jpeg", "image/jpg", "image/png", "image/gif"],
      videoFiles: [
        "video/mp4",
        "video/mp4v",
        "video/mpg4",
        "video/m4v",
        "video/quicktime",
        "video/avi",
        "video/wmv",
        "video/mkv",
        "video/mk3d",
        "video/mks",
        "video/webm"
      ],
      applicationFiles: [
        "application/pdf",
        "text/plain",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/hwp",
        "application/zip",
        "application/x-hwp",
        "application/zip-compressed",
        "application/x-zip-compressed"
      ],
      inputFile: null,
    };
  },
  created() { },

  methods: {
    allowImgExt() {
      return this.imageFiles;
    },

    allowExt() {
      return this.imageFiles.concat(this.videoFiles);
    },

    allowDocumentExt() {
      return this.imageFiles.concat(this.videoFiles, this.applicationFiles);
    },

    openFileUpload(type) {
      document.getElementById(type).click();
    },

    // 파일 추가(add files)
    addFiles() {
      this.$refs.files.click();
    },

    // 파일 업로드(upload file)
    uploadFile(e, type) {
      if (this.form.image && this.form.image.length >= 5) {
        console.log('최대 5장까지만 업로드할 수 있습니다.');
        this.$snackOpen({
          contents: this.$t("S20137"),
        });
        return;
      }

      let formData = new FormData();
      // let uploadedFiles = this.$refs.files.files;
      let uploadedFiles = e.target.files;
      let inputType = { fileType: e.target.name };

      for (let i = 0; i < uploadedFiles.length; i++) {
        formData.append("file", uploadedFiles[i]);
      }

      httpService
        .upload(formData)
        .then((response) => {
          if (type === "CHAT" && this.attachments.length === 1) {
            this.attachments = response.data.data;
          } else {
            this.attachments = this.attachments.concat(response.data.data);
          }

          if (this.isComment) {
            let mergedObject = { ...response.data.data[0], ...inputType };
            this.form.images.push(mergedObject);
          } else {
            if (this.form.image) {
              if (Array.isArray(this.form.image)) {
                this.form.image = [...this.form.image, { ...response.data.data[0], ...inputType }];
              } else {
                this.form.image = [this.form.image, { ...response.data.data[0], ...inputType }];
              }
            } else {
              this.form.image = [{ ...response.data.data[0], ...inputType }];
            }
          }
        })
        .catch((err) => {
          console.log("FAILURE!!", err);
        });

      // this.submitFiles()
      if (e.target.value && e.target.value.length > 0) {
        e.target.value = "";
      }
    },

    // 파일 업로드(upload file)
    checklistUploadFile(e, type) {
      if (this.form.images && this.form.images.length >= 5) {
        console.log('최대 5장까지만 업로드할 수 있습니다.');
        this.$snackOpen({
          contents: this.$t("S20137"),
        });
        return;
      }

      let formData = new FormData();
      // let uploadedFiles = this.$refs.files.files;
      let uploadedFiles = e.target.files;
      let inputType = { fileType: e.target.name };

      for (let i = 0; i < uploadedFiles.length; i++) {
        formData.append("file", uploadedFiles[i]);
      }

      httpService
        .upload(formData)
        .then((response) => {
          if (type === "CHAT" && this.attachments.length === 1) {
            this.attachments = response.data.data;
          } else {
            this.attachments = this.attachments.concat(response.data.data);
          }

          if (this.isComment) {
            let mergedObject = { ...response.data.data[0], ...inputType };
            this.form.images.push(mergedObject);
          } else {
            if (this.form.images) {
              if (Array.isArray(this.form.images)) {
                this.form.images = [...this.form.images, { ...response.data.data[0], ...inputType }];
              } else {
                this.form.images = [this.form.images, { ...response.data.data[0], ...inputType }];
              }
            } else {
              this.form.images = [{ ...response.data.data[0], ...inputType }];
            }
          }
        })
        .catch((err) => {
          console.log("FAILURE!!", err);
        });

      // this.submitFiles()
      if (e.target.value && e.target.value.length > 0) {
        e.target.value = "";
      }
    },

    // 파일 삭제
    deleteAttachment() {
      this.attachments = [];
    },

    // 파일 강제 다운로드(file force download)
    donwloadFile(fileInfo) {
      let fileName = fileInfo.file.id
        ? fileInfo.file.originalName
        : fileInfo.split("/").pop();
      let resourceUri = fileInfo.file.id ? fileInfo.file.resourceUri : fileInfo;

      httpService
        .fileDownload(resourceUri)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          console.log("error occured");
        });
    },

    downloadFileOnMobile(fileInfo) {
      const url = new URL(fileInfo.file.resourceUri, window.location.origin);
      url.searchParams.set("linkType", "INTERNAL_LINK");
      window.location.href = url.toString();
    },

    deleteFileIndex(index) {
      this.attachments.splice(index, 1);
    },

    toggleDocument() {
      this.documentshow = !this.documentshow;
      this.form.comment = "";
      this.filterTextArea();
    },

    filterTextArea() {
      const textFields = document.querySelectorAll(".mdc-text-field");
      textFields.forEach((textField) => {
        new MDCTextField(textField);
      });
      new MDCTextField(
        document.querySelector(".mdc-text-field_answer" + this.numberValue)
      );
      setTimeout(() => {
        new MDCTextField(
          document.querySelector(".answer-text-area" + this.numberValue)
        );
      }, 300);
    },


    /**
     *
     * @param {String} contentType 미디어 파일 타입 체크
     * @returns {*}
     */
    getType(contentType) {
      if (contentType) {
        return contentType.split("/")[0];
      }
    },

    removeImage() {
      this.form.image = null;
    },

    removeSpecificImage(index) {
      console.log('removeSpecificImage', index);
      this.form.image.splice(index, 1);
    },

    /**
     * 비디오 플레이어 옵션 메소드
     *
     * @param {object} img 미디어 데이터 오브젝트
     * @param height 디폴트 매개변수 미디어 높이
     * @param width 디폴트 매개변수 미디어 넓이
     * @returns {{playbackRates: number[], sources: [{src: (null|*), type}], width: (*|string), language: string, muted: boolean, poster: *, height: (*|string)}}
     */
    getPlayerOption(img, height, width) {
      return {
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: img.contentType,
            src: img.resourceUri
          }
        ],
        height: height ? height : "100%",
        width: width ? width : "100%",
        poster: img.subFileResourceUri[0]
          ? img.subFileResourceUri[0]
          : ''
      };
    },

    /**
     * 미디어 파일 유효성 체크 메소드
     * @param {Object} file 미디어 파일 객체
     * @param {String} type 미디어 파일 익스텐션 타입
     * @returns {boolean}
     */
    mediaTypeValidCheck(file, type) {
      if (!file) return false;
      if (!this.ValidateExtensionType(file, type)) return false;
      return this.validateSizeInput(file.size);
    },

    validateSizeInput(input) {
      if (this.getByte(input) > 900) {
        return false;
      } else {
        return true;
      }
    },

    ValidateExtensionType(file, type) {
      // file.type = "";
      switch (type) {
        case "ALL":
          if (!this.allowDocumentExt().includes(file.type) || !file.name.indexOf(".hwp")) {
            return false;
          } else {
            return true;
          }
        case "IMAGE":
          if (!this.allowImgExt().includes(file.type)) {
            return false;
          } else {
            return true;
          }

        case "MEDIA":
          if (!this.allowExt().includes(file.type)) {
            return false;
          } else {
            return true;
          }
        default:
          return false;
      }
    },

    getByte(size) {
      return Math.floor(size / 1024 ** 2);
    },

    checkImgVideoFile(file) {
      if (typeof file === "string") {
        const fileSplitList = file.split(".");
        const fileExt = fileSplitList[fileSplitList.length - 1]
        const isImage = this.imageFiles.includes(`image/${fileExt}`)
        const isVideo = this.videoFiles.includes(`video/${fileExt}`)
        return isImage ? "IMAGE" : isVideo ? "VIDEO" : "";
      }
    },
  },
};
